/// <amd-module name="Repos/Editor/Components/DiffViewer" />
import * as React from "react";
import { IDiffViewerProps } from "Repos/Common/Contracts/Editor";
import { ErrorBoundary } from "VSS/Platform/Components/ErrorBoundary";
import { Components, css } from "VSS/Platform/Layout";
import { BinaryDiffViewer } from "./BinaryViewer";
import { CodeDiffEditor } from "./CodeDiffEditor";
import { ImageDiffViewer } from "./ImageViewer";

export const DiffViewer = (props: IDiffViewerProps) => {
    let content: JSX.Element | null = null;
    let wrapperClassName: string | undefined;
    if (props.modifiedContent.metadata.isBinary) {
        wrapperClassName = "";
        if (props.modifiedContent.metadata.isImage && props.getModifiedDownloadUrl && props.getOriginalDownloadUrl) {
            content = (
                <ImageDiffViewer
                    diffOrientation={props.diffOrientation}
                    isPixelDiff={props.isPixelDiff}
                    modifiedContent={props.modifiedContent}
                    modifiedContentUrl={props.getModifiedDownloadUrl()}
                    onLoaded={props.onLoaded}
                    originalContent={props.modifiedContent}
                    originalContentUrl={props.getOriginalDownloadUrl()}
                />
            );
        } else {
            content = (
                <BinaryDiffViewer
                    getModifiedDownloadUrl={props.getModifiedDownloadUrl}
                    getOriginalDownloadUrl={props.getOriginalDownloadUrl}
                    modifiedContent={props.modifiedContent}
                    onLoaded={props.onLoaded}
                    originalContent={props.originalContent}
                />
            );
        }
    } else {
        wrapperClassName = props.editorClassName;
        content = (
            <CodeDiffEditor
                addDiffKeyboardShortcuts={props.addDiffKeyboardShortcuts}
                diffOrientation={props.diffOrientation}
                diffWidgets={props.diffWidgets}
                editable={props.editable}
                isPixelDiff={props.isPixelDiff}
                modifiedContent={props.modifiedContent}
                scrollToLine={props.scrollToLine}
                onContentChanged={props.onContentChanged}
                onDiffOrientationChanged={props.onDiffOrientationChanged}
                onLoaded={props.onLoaded}
                originalContent={props.originalContent}
                showMarginForIcons={props.showMarginForIcons}
                initialSelectedText={props.initialSelectedText}
                getCodeSelectionLinkUrl={props.getCodeSelectionLinkUrl}
            />
        );
    }

    return (
        <ErrorBoundary handlerComponentType="tfs.page-error-handler">
            <div className={css(props.className, wrapperClassName)}>{content}</div>
        </ErrorBoundary>
    );
};

Components.add("repos-diff-viewer", DiffViewer);
